const state = {
  isRegistered: false, //通道注册状态
  iscalling: false, //是否通话中
  isincall: false, //是否呼入
}

const mutations = {
  SET_IS_REGISTERED: (state, isRegistered) => {
    state.isRegistered = isRegistered
  },
  SET_IS_CALLING: (state, iscalling) => {
    state.iscalling = iscalling
  },
  SET_IS_IN_CALL: (state, isincall) => {
    state.isincall = isincall
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/webrtc.js